export class Question {
    id: number;
    oldId: string;
    description: string;
    active: boolean;
    font: string;
    highlighted?: boolean;
    hovered?: boolean;
    answerSelected: number;
    themeName?: string;
}
